var beneficiaryRelationshipCodes = {
    "Other": "OTH",
    "Spouse": "SPS",
    "DomesticPartner": "DPR",
    "Child": "CHD",
    "Sibling": "SIB",
    "Grandchild": "GDC",
    "Parent": "PAR"
};

export default beneficiaryRelationshipCodes;